import { Directive, inject, Signal, signal } from '@angular/core';
import { ResponsiveService } from '../../services/responsive.service';

@Directive()
export abstract class ResponsiveBaseComponent {
    protected responsiveService = inject(ResponsiveService);

    isHandset = signal(false);
    isTablet = signal(false);
    isDesktop = signal(false);

    constructor() {
        this.responsiveService.isHandset$.subscribe(value => this.isHandset.set(value));
        this.responsiveService.isTablet$.subscribe(value => this.isTablet.set(value));
        this.responsiveService.isDesktop$.subscribe(value => this.isDesktop.set(value));
    }
}
